import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
function PaymentLogoMasterCard(_ref) {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoMasterCard',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 33,
    height: 22,
    viewBox: "0 0 33 22"
  }, props), /*#__PURE__*/React.createElement(Group, {
    fill: "none"
  }, /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFF",
    d: "M0 0H32.847V21.975H0z",
    opacity: "0"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF5F00",
    d: "M10.144 1.898H18.735V15.857H10.144z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#EB001B",
    d: "M11.0286025,8.879045 C11.0264454,6.15562071 12.2831893,3.58245345 14.4367222,1.90096281 C10.7782087,-0.959298393 5.52443654,-0.542676614 2.36761566,2.85803756 C-0.78920522,6.25875173 -0.78920522,11.501804 2.36761566,14.9025182 C5.52443654,18.3032324 10.7782087,18.7198542 14.4367222,15.8595929 C12.282504,14.1775683 11.0256833,11.6033346 11.0286025,8.879045 Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F79E1B",
    d: "M28.8747564,8.879045 C28.8747564,12.2776867 26.9239291,15.3779451 23.8510034,16.8631284 C20.7780777,18.3483118 17.1224666,17.9576766 14.4367222,15.8571272 C16.5893154,14.174209 17.8461538,11.6013839 17.8461538,8.87781213 C17.8461538,6.15424038 16.5893154,3.58141524 14.4367222,1.89849706 C17.1224666,-0.202052351 20.7780777,-0.592687512 23.8510034,0.892495826 C26.9239291,2.37767917 28.8747564,5.47793751 28.8747564,8.87657925 L28.8747564,8.879045 Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F79E1B",
    d: "M30.23,17 L30.23,16.1714286 L30.3966667,16.1714286 L30.3966667,16 L30,16 L30,16.1714286 L30.1566667,16.1714286 L30.1566667,17 L30.23,17 Z M31,17 L31,16 L30.88,16 L30.74,16.7142857 L30.6,16 L30.48,16 L30.48,17 L30.5666667,17 L30.5666667,16.2428571 L30.6966667,16.8928571 L30.7866667,16.8928571 L30.9166667,16.2428571 L30.9166667,17 L31,17 Z"
  })));
}
PaymentLogoMasterCard.displayName = 'PaymentLogoMasterCard';
export default withProvisionalOverrideFromContext(PaymentLogoMasterCard);
//# sourceMappingURL=index.js.map